import classNames from 'classnames';
import React__default from 'react';
import { getPrefixCls } from '../../../utils/getPrefix.js';

var prefixCls = getPrefixCls('skeleton');
function Image(_ref) {
  var width = _ref.width,
    height = _ref.height,
    className = _ref.className,
    _ref$dataTestid = _ref.dataTestid,
    dataTestid = _ref$dataTestid === void 0 ? 'skeletonImage' : _ref$dataTestid;
  return /*#__PURE__*/React__default.createElement("span", {
    "sl-test-data": dataTestid,
    className: classNames("".concat(prefixCls), "".concat(prefixCls, "-image"), className),
    style: {
      width: "".concat(width, "px"),
      height: "".concat(height, "px")
    }
  });
}

export { Image };
